<template lang="pug">
  div
    app-divider(
      label="Dados Gerais",
    )
    el-row(:gutter="30")
      el-col(:span="12")
        el-row
          app-label.margin-button(
            :label="'Código ' + ORGAO",
            :required="true"
          )
        el-row
          validation-provider(rules="required", v-slot="{ errors }")
            el-input.input(
              v-model="numero",
              @blur="$emit('setCodigo', $event.target.value)",
              name="Codigo",
              :class="{'erro' : errors.length}",
              :maxlength="100"
            )
            span.help.erro {{ errors[0] }}
</template>

<script>
import AppLabel from '@/components/AppLabel'
import AppDivider from './AppDivider'
import { mapState } from 'vuex'

export default {

  components: {
    AppLabel,
    AppDivider
  },

  props: {
    numeroIterpa: {
      type: String,
      required: false
    }
  },

  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    })
  },

  data () {
    return {
      numero: this.numeroIterpa
    }
  }

}
</script>

<style lang="scss" scoped>
.margin-button {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDadosGeraisOs.vue